import { render, staticRenderFns } from "./commingsoon.vue?vue&type=template&id=50f19133&scoped=true"
import script from "./commingsoon.vue?vue&type=script&lang=js"
export * from "./commingsoon.vue?vue&type=script&lang=js"
import style0 from "./commingsoon.vue?vue&type=style&index=0&id=50f19133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f19133",
  null
  
)

export default component.exports